export default __webpack_public_path__ + "static/media/data.e9831a49.svg";